import React, { useState, useEffect } from 'react';
import { Col, Row, Modal, ModalBody, Button, Nav, TabPane, Table, TabContent, CustomInput } from 'reactstrap';
import { InputForm, Loader, NavItemCustom, SelectForm, TableWithVirtualizedRow } from '../Basicos';
import { axiosApi } from '../Basicos/axiosInstances';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { dateAndHourLaravel, dateToPtBr } from '../Basicos/funcoes';
import { AiFillFileExcel } from 'react-icons/ai';
import FileServer from 'file-saver';


export default function ModalGerenciamentoProva({
    isOpen, dadosModal, id, ativar, openModal, setDadosGerenciamento
}) {
    const style = {
        col2: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
        col4: { xs: 6, md: 3, sm: 3, lg: 3, xl: 3 },
        col5: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
        col6: { xs: 2, md: 2, sm: 2, lg: 2, xl: 2 }
    };
    const [dados, setDados] = useState(dadosModal);
    const [tab, setTab] = useState(1);
    const [qtdCampos, setQtdCampos] = useState(1);
    const [conteudo, setConteudo] = useState([]);
    const [carregado, setCarregado] = useState(false);
    const [professoresEmail, setProfessoresEmail] = useState(new Set());
    const [enviarProfessores, setEnviarProfessores] = useState([]);
    const [professoresModificados, setProfessoresModificados] = useState({});
    const [statusOptions, setStatusOptions] = useState([]);
    const [aba3, setAba3] = useState({}); // Armazena os IDs dos professores e seus status alterados
    const [conteudosTab4, setConteudosTab4] = useState([]);
    const [alteracoesConteudo, setAlteracoesConteudo] = useState([]);
    const [dadosProfessores, setDadosProfessores] = useState({});
    const [professores, setProfessores] = useState([]);
    const [feriados, setFeriados] = useState([]);
    const [loader, setLoader] = useState(false);
    const options = [
        { value: true, label: "Sim" },
        { value: false, label: "Não" }
    ]

    useEffect(() => {
        if (isOpen) {
            setCarregado(false);
            setDados(dadosModal)
            getStatus();
            getGerenciamentoCompleto();
            getFeriados();
            setAba3({}); // Limpa o estado aba3 quando o modal é carregado
        }
    }, [isOpen == true]);

    const alterTab = (value) => {
        // Quando mudamos para a aba 3, verificamos os professores selecionados na aba 2
        if (value === 3) {

            // Cria um conjunto com todos os professores atualmente na aba 2
            const professoresAtivos = new Set();

            // Verifica todos os professores atualmente presentes nas aulas
            conteudo.forEach(item => {
                (item.professores || []).forEach(prof => {
                    if (prof.id) {
                        professoresAtivos.add(prof.id);
                    }
                });
            });

            // Atualiza o conjunto mantendo apenas os professores ativos
            // ou seja, aqueles que ainda estão presentes em pelo menos uma aula
            setProfessoresEmail(professoresAtivos);

            // Também forçamos uma renderização dos dados modificados
            setProfessoresModificados({ ...professoresModificados });
        }

        // Ao abrir a aba de Alterações, marca como vistas para o usuário atual
        if (value === 5 && dados?.id) {
            axiosApi.post(`gerenciamento-prova/${dados.id}/marcar-alteracoes-vistas`)
                .then(() => {
                    if (setDadosGerenciamento) {
                        setDadosGerenciamento(prev => prev.map(item => (
                            item.id === dados.id
                                ? { ...item, tem_alteracao_conteudo: false, qtd_alteracoes_nao_vistas: 0 }
                                : item
                        )));
                    }
                })
                .catch(() => { });
        }

        setTab(value);
    }

    const getGerenciamentoCompleto = async () => {
        try {
            const { data } = await axiosApi.get(`gerenciamento-prova/${dadosModal.id}`);

            // Formata o conteúdo e adiciona status_id diretamente a cada professor
            const conteudoFormatado = (data.conteudo_formatado || []).map((item, idx) => ({
                ...item,
                id: item.id ?? idx, // Garante id único se não existir
                professores: (item.professores || []).map(prof => ({
                    ...prof,
                    status_id: prof.conteudo_prova_professor?.status_id ?? 1
                }))
            }));

            // Sincroniza professoresModificados com status_id retornado
            const novosProfessoresModificados = {};

            // Coleta apenas os IDs dos professores já selecionados para a aba 3
            const professoresSelecionadosIds = new Set();

            conteudoFormatado.forEach(item => {
                // Adiciona apenas os professores já selecionados
                (item.professores || []).forEach(prof => {
                    if (prof.id) {
                        // Adiciona ao conjunto para a aba 3
                        professoresSelecionadosIds.add(prof.id);

                        // Atualiza professoresModificados com o status_id
                        novosProfessoresModificados[prof.id] = {
                            ...novosProfessoresModificados[prof.id],
                            status_id: prof.status_id
                        };
                    }
                });
            });
            setConteudo(conteudoFormatado);

            // Atualiza o estado apenas com os professores selecionados
            setProfessoresEmail(professoresSelecionadosIds);
            setProfessoresModificados(novosProfessoresModificados);
            setConteudosTab4(data.conteudo_aba);
            setAlteracoesConteudo(data.alteracoes_conteudo || []);
        } finally {
            setCarregado(true);
        }
    }

    const getStatus = async () => {
        const response = await axiosApi.get("status-professor-prova");
        setStatusOptions(response.data.map(element => ({ label: element.descricao, value: element.id })))
    }

    const getFeriados = async () => {
        try {
            const { data } = await axiosApi.get('/auxiliares/feriado');
            setFeriados(data.dados || []);
        } catch (error) {
            console.error("Erro ao buscar feriados:", error);
        }
    }

    const getExportDownload = async () => {
        try {
            if (!conteudosTab4 || conteudosTab4.length === 0) return;

            const gerenciamentoProvaId = dadosModal?.id ?? id;
            var params = {
                gerenciamento_prova_id: gerenciamentoProvaId
            }
            await axiosApi.post(`exportacao/xlsx/conteudo-prova-gerenciamento`, params, {
                responseType: 'blob',
            }).then((res) => {
                const titulo = dadosModal?.titulo ?? dados?.titulo ?? 'Conteudo';
                const turmaDesc = dadosModal?.turma ? ` - ${dadosModal.turma}` : '';
                const fileName = `Conteudo - ${titulo}${turmaDesc}.xlsx`;
                const file = new File([res.data], fileName, { type: `${res?.data?.Blob?.type};charset=utf-8` });
                FileServer.saveAs(file);
            });
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeCampos = (evento, index, indexConteudo) => {
        // Cria uma cópia do conteúdo atual
        const novoConteudo = conteudo.map(item => ({ ...item, professores: [...(item.professores || [])] }));

        // Encontra o índice do conteúdo que foi clicado
        const conteudoIndex = novoConteudo.findIndex(item => item.id === indexConteudo);

        if (conteudoIndex === -1) return;

        const conteudoAtual = novoConteudo[conteudoIndex];

        if (evento === "mais") {
            const professoresDisponiveis = conteudoAtual.professores_disponiveis || [];
            const professoresAssociados = new Set(conteudoAtual.professores.map(prof => prof.id));
            const professoresDispNaoAssociados = professoresDisponiveis.filter(
                prof => !professoresAssociados.has(prof.id)
            );

            if (professoresDispNaoAssociados.length === 0) {
                ativar(400, "Não há mais professores disponíveis para adicionar a esta aula!");
                return;
            }

            // Determinar se estamos trabalhando com aula ou serviço
            const isAula = Boolean(conteudoAtual?.aula);

            const novoProfessor = {
                id: undefined,
                nome: '',
                conteudo_prova_professor: {
                    qtd_questoes_objetivas: "",
                    qtd_questoes_subjetivas: "",
                    // Adicionar o campo aula_id ou servico_id apropriado
                    aula_id: isAula ? conteudoAtual?.aula?.id : null,
                    servico_id: !isAula ? conteudoAtual.id : null,
                    titulo: conteudoAtual?.titulo ?? (conteudoAtual?.professores?.[0]?.conteudo_prova_professor?.titulo ?? conteudoAtual?.aula?.titulo ?? conteudoAtual?.aula?.descricao)
                }
            };

            novoConteudo[conteudoIndex].professores.push(novoProfessor);
            setConteudo(novoConteudo);
            // Não adicionamos ao professoresEmail aqui porque o professor ainda não tem um ID definido
        }

        if (evento === "menos") {
            if (!conteudoAtual.professores || conteudoAtual.professores.length <= 1) {
                ativar(400, "É necessário pelo menos um professor para este conteúdo!");
                return;
            }
            // Armazena a referência ao professor que será removido
            const professorRemovido = conteudoAtual.professores[index];

            // Verifica se o professor removido tinha um ID definido
            if (professorRemovido && professorRemovido.id) {
                // Remove o professor da aula atual
                novoConteudo[conteudoIndex].professores.splice(index, 1);

                // Verifica se este professor ainda existe em alguma outra aula
                let professorExisteEmOutraAula = false;

                // Percorre todas as aulas (exceto a atual que já foi modificada)
                novoConteudo.forEach((item, idx) => {
                    // Pula a aula de onde o professor foi removido (já atualizada)
                    if (idx !== conteudoIndex) {
                        // Verifica se o professor existe em outra aula
                        const professorEncontrado = (item.professores || []).some(
                            prof => prof.id === professorRemovido.id
                        );

                        if (professorEncontrado) {
                            professorExisteEmOutraAula = true;
                        }
                    }
                });

                if (professorExisteEmOutraAula) {
                    // O professor ainda existe em outra aula, mantém na aba 3
                    const novoSet = new Set(professoresEmail);
                    novoSet.add(professorRemovido.id);
                    setProfessoresEmail(novoSet);

                    // Armazenamos informações sobre a aula de onde o professor foi removido
                    // mas continuamos mantendo o professor na aba 3
                    setProfessoresModificados(prevState => ({
                        ...prevState,
                        [professorRemovido.id]: {
                            ...(prevState[professorRemovido.id] || {}),
                            // Registramos que este professor foi removido dessa aula específica
                            removido_de_aula_id: conteudoAtual.id,
                            removido_de_aula_titulo: conteudoAtual.titulo || conteudoAtual.aula?.titulo || conteudoAtual.aula?.descricao || 'Aula'
                        }
                    }));
                } else {
                    // O professor não existe mais em nenhuma aula, remove da aba 3
                    const novoSet = new Set(professoresEmail);
                    novoSet.delete(professorRemovido.id);
                    setProfessoresEmail(novoSet);

                    // Remove o professor do objeto professoresModificados também
                    setProfessoresModificados(prevState => {
                        const novoState = { ...prevState };
                        delete novoState[professorRemovido.id];
                        return novoState;
                    });
                }
            } else {
                // Professor sem ID, simplesmente remove da lista
                novoConteudo[conteudoIndex].professores.splice(index, 1);
            }

            setConteudo(novoConteudo);
        }
    };

    const onChange = (nome, valor) => {
        setDados({ ...dados, [nome]: valor });
    }

    const onChangeProfessor = (nome, valor, indice, indice2) => {
        switch (nome) {
            case "email":
            case "telefone": {
                // Atualiza os dados no professoresModificados para exibição imediata
                setProfessoresModificados(prevState => ({
                    ...prevState,
                    [indice]: { ...(prevState[indice] || {}), [nome]: valor }
                }));

                // Armazena separadamente os IDs dos professores que tiveram email ou telefone alterados
                // para envio posterior quando clicar em salvar
                setAba3(prevAba3 => ({
                    ...prevAba3,
                    [indice]: {
                        ...prevAba3[indice],  // Preserva alterações anteriores (email ou telefone)
                        professor_id: indice,
                        [nome]: valor
                    }
                }));
            }
            case "status_id": {
                // Atualiza os status no professoresModificados para exibição imediata
                setProfessoresModificados(prevState => ({
                    ...prevState,
                    [indice]: { ...(prevState[indice] || {}), [nome]: valor }
                }));

                // Também armazena alterações de status na variável aba3, junto com email e telefone
                setAba3(prevAba3 => ({
                    ...prevAba3,
                    [indice]: {
                        ...prevAba3[indice],  // Preserva alterações anteriores (email ou telefone)
                        professor_id: indice,
                        [nome]: valor
                    }
                }));
                // Atualiza diretamente na estrutura de conteudo (aba 2)
                const novoConteudo = [...conteudo];
                // Procurar o professor pelo id em todos os itens de conteudo
                novoConteudo.forEach(item => {
                    if (item.professores) {
                        item.professores.forEach(prof => {
                            if (prof.id === indice) {
                                if (!prof.conteudo_prova_professor) prof.conteudo_prova_professor = {};
                                prof.conteudo_prova_professor.status_id = valor; // Usando status_id em vez de nome
                            }
                        });
                    }
                });
                setConteudo(novoConteudo);
                break;
            }
            default:
                // For professor_id, qtd_questoes_objetivas, qtd_questoes_subjetivas
                // Abordagem mais direta para atualizar o professor específico
                const novoConteudo = [...conteudo];
                const conteudoIndex = novoConteudo.findIndex(item => item.id === indice2);

                if (nome === "professor_id") {
                    if (valor) {
                        // Quando um professor válido é selecionado, adicionamos ao conjunto
                        const novoSet = new Set(professoresEmail);
                        novoSet.add(valor);
                        setProfessoresEmail(novoSet);

                        // Também precisamos atualizar imediatamente o professor na aba 2
                        // para garantir que ele tenha todas as informações corretas
                        if (conteudoIndex !== -1) {
                            const professorSelecionado = conteudo[conteudoIndex]?.professores_disponiveis?.find(p => p.id === valor);

                            if (professorSelecionado) {
                                console.log('Professor selecionado encontrado:', professorSelecionado);
                            }
                        }
                    }
                }

                if (conteudoIndex !== -1) {
                    const conteudoAtual = novoConteudo[conteudoIndex];
                    const professoresAtualizados = [...conteudoAtual.professores];

                    if (nome === "professor_id") {
                        // Busca informações completas do professor selecionado
                        const professorCompleto = conteudoAtual.professores_disponiveis?.find(p => p.id === valor) || {
                            id: valor,
                            nome: 'Professor Selecionado' // Nome padrão se não encontrarmos informações completas
                        };

                        // Determinar se estamos trabalhando com aula_id ou servico_id
                        const isAula = Boolean(conteudoAtual?.aula);
                        const idField = isAula ? 'aula_id' : 'servico_id';
                        // Usar o ID real da aula (conteudoAtual.aula.id) em vez do índice (conteudoAtual.id)
                        const idValue = isAula ? conteudoAtual?.aula?.id : conteudoAtual?.id;

                        // Atualiza o professor com informações completas
                        professoresAtualizados[indice] = {
                            ...professoresAtualizados[indice],
                            ...professorCompleto, // Copiamos todas as informações do professor
                            id: valor,
                            [idField]: idValue, // Adicionamos o ID da aula/serviço usando a chave correta
                            aula_titulo: conteudoAtual.titulo || conteudoAtual.aula?.titulo || conteudoAtual.aula?.descricao || 'Aula' // Título da aula para exibição
                        };

                        // Garantimos que o campo conteudo_prova_professor existe e tem o campo correto
                        if (!professoresAtualizados[indice].conteudo_prova_professor) {
                            professoresAtualizados[indice].conteudo_prova_professor = {};
                        }
                        professoresAtualizados[indice].conteudo_prova_professor[idField] = idValue;

                        // Garantimos que o professor esteja no conjunto para a aba 3
                        if (valor) {
                            const novoSet = new Set(professoresEmail);
                            novoSet.add(valor);
                            setProfessoresEmail(novoSet);

                            // Também registramos a associação professor-aula no professoresModificados
                            setProfessoresModificados(prevState => ({
                                ...prevState,
                                [valor]: {
                                    ...(prevState[valor] || {}),
                                    // Armazenamos ou atualizamos o vínculo com a aula ou serviço
                                    [idField]: idValue,
                                    aula_titulo: conteudoAtual.titulo || conteudoAtual.aula?.titulo || conteudoAtual.aula?.descricao || 'Aula'
                                }
                            }));
                        }
                    } else if (nome === "qtd_questoes_objetivas" || nome === "qtd_questoes_subjetivas") {
                        // Determinar se estamos trabalhando com aula ou serviço
                        const isAula = Boolean(conteudoAtual?.aula);

                        // Atualiza o objeto conteudo_prova_professor para campos de questões
                        professoresAtualizados[indice] = {
                            ...professoresAtualizados[indice],
                            conteudo_prova_professor: {
                                ...(professoresAtualizados[indice]?.conteudo_prova_professor || {}),
                                [nome]: valor,
                                // Adicionar o campo aula_id ou servico_id apropriado
                                aula_id: isAula ? conteudoAtual?.aula?.id : professoresAtualizados[indice]?.conteudo_prova_professor?.aula_id || null,
                                servico_id: !isAula ? conteudoAtual.id : professoresAtualizados[indice]?.conteudo_prova_professor?.servico_id || null
                            }
                        };

                        // Também salvamos essas informações no professoresModificados
                        // para que elas apareçam na aba 3
                        const professorId = professoresAtualizados[indice].id;
                        if (professorId) {
                            setProfessoresModificados(prevState => ({
                                ...prevState,
                                [professorId]: {
                                    ...(prevState[professorId] || {}),
                                    [nome]: valor,
                                    // Também salvamos o ID da aula ou serviço
                                    aula_id: isAula ? conteudoAtual?.aula?.id : prevState[professorId]?.aula_id || null,
                                    servico_id: !isAula ? conteudoAtual.id : prevState[professorId]?.servico_id || null,
                                    aula_titulo: conteudoAtual.titulo || conteudoAtual.aula?.titulo || conteudoAtual.aula?.descricao || 'Aula'
                                }
                            }));
                        }
                    } else {
                        // Determinar se estamos trabalhando com aula ou serviço
                        const isAula = Boolean(conteudoAtual?.aula);

                        // Atualiza outros campos
                        professoresAtualizados[indice] = {
                            ...professoresAtualizados[indice],
                            conteudo_prova_professor: {
                                ...(professoresAtualizados[indice]?.conteudo_prova_professor || {}),
                                [nome]: valor,
                                // Adicionar o campo aula_id ou servico_id apropriado
                                aula_id: isAula ? conteudoAtual?.aula?.id : professoresAtualizados[indice]?.conteudo_prova_professor?.aula_id || null,
                                servico_id: !isAula ? conteudoAtual.id : professoresAtualizados[indice]?.conteudo_prova_professor?.servico_id || null
                            }
                        };
                    }

                    // Atualiza o conteúdo específico
                    novoConteudo[conteudoIndex] = {
                        ...conteudoAtual,
                        professores: professoresAtualizados
                    };

                    // Atualiza o estado
                    setConteudo(novoConteudo);
                }

                // Also update dadosProfessores for compatibility with the rest of the code
                setDadosProfessores(prevState => {
                    const novoEstado = { ...prevState };

                    if (!Array.isArray(novoEstado[indice2])) {
                        novoEstado[indice2] = [];
                    }

                    novoEstado[indice2][indice] = {
                        ...novoEstado[indice2][indice],
                        [nome]: valor
                    };

                    return novoEstado;
                });
                break;
        }
    };

    const onChangeCheckbox = (event) => {
        const id = event.target.id;
        const isChecked = event.target.checked;
        setProfessoresModificados(prevState => ({
            ...prevState,
            [id]: { ...(prevState[id] || {}), enviar: isChecked }
        }));
        setEnviarProfessores(prevState => {
            if (isChecked) {
                if (!prevState.includes(id)) {
                    return [...prevState, id];
                }
                return prevState;
            } else {
                return prevState.filter(item => item !== id);
            }
        });
    }

    const salvar = async () => {
        try {
            setLoader(true);
            const hoje = new Date();
            if (dados.data_limite_envio_questoes == undefined || dados.data_limite_envio_questoes == null)
                ativar(400, "Campo de Data Limite obrigatório!");
            else if (dados.codigo_primeira_chamada == undefined || dados.codigo_primeira_chamada == null)
                ativar(400, "Campo de Código 1° Chamada obrigatório!");
            else if (dados.codigo_segunda_chamada == undefined || dados.codigo_segunda_chamada == null)
                ativar(400, "Campo de Código 2° Chamada obrigatório!");
            else if (new Date(dados.data_limite_envio_questoes + 'T00:00:00').getDay() === 0 || new Date(dados.data_limite_envio_questoes + 'T00:00:00').getDay() === 6)
                ativar(400, "A Data Limite Envio não pode ser um sábado ou domingo!");
            else if (feriados.some(f => f.data === dados.data_limite_envio_questoes))
                ativar(400, "A Data Limite Envio não pode ser um feriado!");
            else {
                // Monta o payload separado por abas conforme solicitado
                const payloadPorAba = {
                    aba1: {
                        data_solicitacao_conteudo: hoje.toISOString().split('T')[0],
                        data_limite_envio_questoes: dados.data_limite_envio_questoes,
                        codigo_primeira_chamada: dados.codigo_primeira_chamada,
                        codigo_segunda_chamada: dados.codigo_segunda_chamada,
                        // Inclua outros campos exibidos e editados na aba 1, se houver
                    },
                    aba2: conteudo.map(item => ({
                        item_id: item.id,
                        professores: (item.professores || []).map(prof => ({
                            id: prof.id,
                            nome: prof.nome_social || prof.nome || '',
                            telefone: prof.telefone || '',
                            conteudo_prova_professor: {
                                ...prof.conteudo_prova_professor
                            }
                        }))
                    })),
                    professores_email: Object.entries(professoresModificados).map(([id, obj]) => ({
                        id,
                        ...obj
                    })),
                    // Enviando a variável aba3 com os professores que tiveram status, email ou telefone alterados
                    aba3: aba3

                };

                // Monta o payload estruturado por abas (anterior)
                const payload = {
                    geral: {
                        ...dados,
                        data_solicitacao_conteudo: hoje.toISOString().split('T')[0],
                    },
                    professores_conteudo: conteudo.map(item => ({
                        item_id: item.id,
                        professores: (item.professores || []).map(prof => ({
                            id: prof.id,
                            nome: prof.nome_social || prof.nome || '',
                            telefone: prof.telefone || '',
                            conteudo_prova_professor: {
                                ...prof.conteudo_prova_professor
                            }
                        }))
                    })),
                    professores_email: Object.entries(professoresModificados).map(([id, obj]) => ({
                        id,
                        ...obj
                    }))
                };

                // Para manter compatibilidade com backend atual:
                let infos = { ...payload.geral };
                infos.conteudos_professores = {};
                conteudo.forEach(item => {
                    if (item.professores && item.professores.length > 0) {
                        infos.conteudos_professores[item.id] = item.professores.map(prof => ({
                            professor_id: prof.id,
                            qtd_questoes_objetivas: prof.conteudo_prova_professor?.qtd_questoes_objetivas || "",
                            qtd_questoes_subjetivas: prof.conteudo_prova_professor?.qtd_questoes_subjetivas || ""
                        }));
                    }
                });
                infos.professores_modificados = professoresModificados;
                const url = `/gerenciamento-prova${dados.id ? `/${dados.id}` : ''}`;
                const method = dados.id ? 'put' : 'post';
                const response = await axiosApi[method](url, payloadPorAba);
                setDadosGerenciamento(prev =>
                    prev.map(item =>
                        item.id === infos.id ? response.data.dados : item
                    )
                );

                // Limpa o estado aba3 após salvar com sucesso
                setAba3({});

                ativar(201, "Informações atualizadas com sucesso!");
            }
        } catch (error) {
            ativar(400, error.response?.data?.erro ?? "Erro ao atualizar informações!");
            console.log(error);
        } finally {
            setLoader(false);
        }
    }

    const enviarEmail = async () => {
        try {
            setLoader(true);
            if (enviarProfessores.length > 0) {
                setProfessoresModificados(prev => {
                    const atualizado = {};
                    for (const key in prev) {
                        atualizado[key] = {
                            ...prev[key]
                        };

                        if (enviarProfessores.includes(key)) {
                            atualizado[key].status_id = 2;
                        }
                    }
                    return atualizado;
                });
                const response = await axiosApi.post(`/envio-email-gerenciamento/${dados.id}`, professoresModificados);
                setDadosGerenciamento(prev =>
                    prev.map(item =>
                        item.id === dadosModal.id ? response.data.dados : item
                    )
                );
                // Recarrega o conteúdo do modal a partir do servidor para que o status "Solicitado"
                // recém-gravado não fique desatualizado no estado local (o que faria um "Salvar"
                // seguinte, na aba Conteúdo, reenviar o status antigo e reverter o que foi enviado).
                await getGerenciamentoCompleto();
                ativar(201, "Emails enviados com sucesso!");
            } else
                ativar(400, "Nenhum professor selecionado!");
        } catch (error) {
            ativar(400, error.response.data.erro);
            console.log(error.response);
        }
        finally {
            setLoader(false);
        }
    }

    // A função para salvar status foi incorporada na função salvar() existente

    const toggle = () => {
        openModal([]);
        setQtdCampos(1);
        setTab(1);
        setConteudo([])
        setDados([]);
        setDadosProfessores({});
        setProfessores([]);
        setProfessoresModificados({});
        setProfessoresEmail(new Set());
        setEnviarProfessores([]);
        setConteudosTab4([]); // Limpar o estado de conteudosTab4
        setAba3({}); // Limpa também o estado dos status alterados
    }

    const professoresConteudo2 = (professores, conteudoId) => {
        return professores.map(element => ({
            label: element.nome_social || element.nome,
            value: element.id
        }))
    }

    const professoresConteudo = (professores, conteudoId) => {
        // Find the content item from conteudo state that matches this conteudoId
        const conteudoItem = conteudo.find(item => item.id === conteudoId);

        // Get the IDs of professors already assigned to this content
        const professoresJaAssignados = new Set(
            conteudoItem?.professores?.map(p => p.id) || []
        );

        return professores
            // Filter out professors that are already assigned to this content
            .filter(professor => !professoresJaAssignados.has(professor.id))
            .map(professor => ({
                label: professor.nome_social || professor.nome,
                value: professor.id
            }));
    };

    // O total agora é calculado diretamente do estado conteudo, garantindo atualização dinâmica
    const total = conteudo.reduce(
        (acc, item) => {
            (item.professores || []).forEach(professor => {
                acc.objetivas += Number(professor?.conteudo_prova_professor?.qtd_questoes_objetivas || 0);
                acc.subjetivas += Number(professor?.conteudo_prova_professor?.qtd_questoes_subjetivas || 0);
            });
            return acc;
        },
        { objetivas: 0, subjetivas: 0 }
    );

    const encontrarProfessor = (professorId) => {
        // Primeiro verificamos no estado professoresModificados (para alterações feitas pelo usuário)
        if (professoresModificados[professorId]?.status_id != undefined) {
            return professoresModificados[professorId].status_id;
        }

        // Busca diretamente no array conteudo que contém os dados da API
        for (const item of conteudo) {
            const professor = (item.professores || []).find(prof => prof.id === professorId);
            if (professor?.conteudo_prova_professor?.status_id != null) {
                return professor.conteudo_prova_professor.status_id;
            }
        }

        // Fallback: verifica em dadosProfessores
        for (const chave in dadosProfessores) {
            const lista = dadosProfessores[chave];
            if (Array.isArray(lista)) {
                const encontrado = lista.find(item => item && item.professor_id === professorId);
                if (encontrado?.status_id != null) {
                    return encontrado.status_id;
                }
            }
        }

        // Status padrão
        return 1;
    }

    // Função utilitária para formatar data no padrão brasileiro solicitado
    function formatarDataVisualizado(dataStr) {
        if (!dataStr || typeof dataStr !== 'string') return '';
        // Garante compatibilidade com Date
        let dataObj;
        try {
            dataObj = new Date(dataStr.replace(' ', 'T'));
        } catch {
            return '';
        }
        if (!dataObj || isNaN(dataObj.getTime())) return '';
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
        const ano = dataObj.getFullYear();
        const hora = String(dataObj.getHours()).padStart(2, '0');
        const minuto = String(dataObj.getMinutes()).padStart(2, '0');
        return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    }

    const encontrarDataVisualizado = (professorId) => {
        for (const chave in dadosProfessores) {
            const lista = dadosProfessores[chave];
            // Verificamos se lista existe e é um array antes de chamar .find()
            if (Array.isArray(lista)) {
                const encontrado = lista.find(item => item && item.professor_id === professorId);
                if (encontrado)
                    return encontrado.data_visualizado;
            }
        }
        return null;
    }


    // Diagnóstico: Mostra os ids de cada item de conteudo
    const idsDuplicados = conteudo.map(c => c.id).filter((id, idx, arr) => arr.indexOf(id) !== idx);
    if (idsDuplicados.length) {
        console.warn('Há ids duplicados em conteudo:', idsDuplicados);
    }
    return (
        <Modal className={`modal-gerenciamento-${qtdCampos}`} isOpen={isOpen}>
            {loader && <Loader overlay={true} />}
            <ModalBody className={`gerenciamento-provas ${tab == 1 ? 'tab1' : ''}`} >
                <Row className="titulo-modal-gerenciamento">
                    <Row>
                        <h3><b>Gerenciamento de Prova</b></h3>
                    </Row>
                    <Row className="titulo-gerenciamento-prova-2">
                        {dados.length != 0 &&
                            <>
                                <div className="text-center w-100">
                                    <h5><b>
                                        {dados.periodo_letivo.descricao} - {dados.semestre.descricao} - {dados.titulo}
                                    </b></h5>
                                </div>
                                <div className="text-center w-100">
                                    <h5><b>
                                        {dados.aula.tipo_de_atividade.nome} - {dateToPtBr(dados.data_prova)}
                                    </b></h5>
                                </div>
                                {dados?.turmas_divergentes && (
                                    <div className="text-center w-100 mt-2 mb-1">
                                        <span
                                            style={{
                                                color: '#c53030',
                                                backgroundColor: '#fff5f5',
                                                border: '1px solid #feb2b2',
                                                borderRadius: '30px',
                                                padding: '4px 12px',
                                                fontSize: '0.8rem',
                                                fontWeight: 'bold',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                boxShadow: '0 2px 8px rgba(197, 48, 48, 0.12)',
                                            }}
                                        >
                                            <span style={{
                                                width: '8px',
                                                height: '8px',
                                                backgroundColor: '#e53e3e',
                                                borderRadius: '50%',
                                                display: 'inline-block'
                                            }} />
                                            Previsto apenas para a {dados.previsto_turma_1 ? 'Turma 1' : 'Turma 2'}
                                        </span>
                                    </div>
                                )}
                                {carregado && conteudo.length === 0 && (
                                    <div className="text-center w-100 mt-2 mb-1">
                                        <span
                                            style={{
                                                color: '#b7791f',
                                                backgroundColor: '#fefcbf',
                                                border: '1px solid #fef08a',
                                                borderRadius: '30px',
                                                padding: '4px 12px',
                                                fontSize: '0.8rem',
                                                fontWeight: 'bold',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                boxShadow: '0 2px 8px rgba(183, 121, 31, 0.12)',
                                            }}
                                        >
                                            <span style={{
                                                width: '8px',
                                                height: '8px',
                                                backgroundColor: '#d69e2e',
                                                borderRadius: '50%',
                                                display: 'inline-block'
                                            }} />
                                            Atenção: Esta prova não possui conteúdo cadastrado.
                                        </span>
                                    </div>
                                )}
                            </>
                        }
                    </Row>
                    <Nav tabs className="tabs-gerenciamento">
                        <NavItemCustom tabs classNamePai="tab-pai" classname="tabs-item-gerenciamento" activeTab={tab}
                            onClick={() => alterTab(1)}
                            descricao={"Geral"}
                            id={1}
                        />
                        <NavItemCustom tabs classNamePai="tab-pai" classname="tabs-item-gerenciamento" activeTab={tab}
                            onClick={() => alterTab(2)}
                            descricao={"Professores x Conteúdo"}
                            id={2}
                        />
                        <NavItemCustom tabs classNamePai="tab-pai" classname="tabs-item-gerenciamento" activeTab={tab}
                            onClick={() => alterTab(3)}
                            descricao={"Professores x Email"}
                            id={3}
                        />
                        <NavItemCustom tabs classNamePai="tab-pai" classname="tabs-item-gerenciamento" activeTab={tab}
                            onClick={() => alterTab(4)}
                            descricao={"Conteúdo"}
                            id={4}
                        />
                        <NavItemCustom tabs classNamePai="tab-pai" classname="tabs-item-gerenciamento" activeTab={tab}
                            onClick={() => alterTab(5)}
                            descricao={(() => {
                                const qtdNovas = alteracoesConteudo.filter((a) => a.novo).length;
                                return `Alterações${qtdNovas > 0 ? ` (${qtdNovas})` : ''}`;
                            })()}
                            id={5}
                        />
                    </Nav>
                </Row>
                <TabContent activeTab={tab}>
                    <TabPane tabId={1}>
                        <Table striped>
                            <Row>
                                <InputForm
                                    name="qtd_questoes_objetivas"
                                    label="Qtde. Questões Múltipla Escolha"
                                    value={total.objetivas}
                                    onChange={onChange}
                                    readOnly
                                    style={{ col: style.col4 }}
                                />
                                <InputForm
                                    name="qtd_questoes_subjetivas"
                                    label="Qtde. Questões Discursivas"
                                    value={total.subjetivas}
                                    onChange={onChange}
                                    readOnly
                                    style={{ col: style.col4 }}
                                />
                                <InputForm
                                    readOnly
                                    type="date"
                                    name="data_solicitacao_conteudo"
                                    label="Data Solicitação"
                                    value={dados?.data_solicitacao_conteudo ?? ""}
                                    onChange={onChange}
                                    style={{ col: style.col4 }}
                                />
                                <InputForm
                                    required={true}
                                    type="date"
                                    name="data_limite_envio_questoes"
                                    label="Data Limite Envio"
                                    value={dados?.data_limite_envio_questoes ?? ""}
                                    onChange={onChange}
                                    style={{ col: style.col4 }}
                                />
                            </Row>
                            <Row>
                                <InputForm
                                    required={true}
                                    name="codigo_primeira_chamada"
                                    label="Código 1° Chamada (Sistema LIT)"
                                    value={dados?.codigo_primeira_chamada ?? ""}
                                    onChange={onChange}
                                    style={{ col: style.col3 }}
                                />
                                <InputForm
                                    required={true}
                                    name="codigo_segunda_chamada"
                                    label="Código 2° Chamada (Sistema LIT)"
                                    value={dados?.codigo_segunda_chamada ?? ""}
                                    onChange={onChange}
                                    style={{ col: style.col3 }}
                                />
                            </Row>
                        </Table>
                    </TabPane>
                    <TabPane className="itens-ciclo" tabId={2}>
                        <Table striped>
                            {conteudo?.map((item) => {
                                const tituloItem = item?.titulo ?? (item?.aula?.titulo ?? item?.aula?.descricao);

                                let textoAviso = "";
                                // Usar diretamente os campos turmas_divergentes calculados no backend
                                if (item?.turmas_divergentes) {
                                    if (item?.previsto_turma_1 && !item?.previsto_turma_2) {
                                        textoAviso = "Previsto apenas na Turma 1";
                                    } else if (!item?.previsto_turma_1 && item?.previsto_turma_2) {
                                        textoAviso = "Previsto apenas na Turma 2";
                                    }
                                }
                                // Fallback: verificar via conteudosTab4 caso o campo direto não esteja disponível
                                if (!textoAviso) {
                                    const itemTab4 = conteudosTab4?.find(c => {
                                        const tituloTab4 = c.titulo ?? (c.aula_id !== null ? c.aula?.titulo : c.servico_descricao?.titulo);
                                        return tituloTab4 === tituloItem;
                                    });
                                    if (itemTab4) {
                                        const temTurma1 = itemTab4.data_1 && itemTab4.data_1.length > 0;
                                        const temTurma2 = itemTab4.data_2 && itemTab4.data_2.length > 0;
                                        if (temTurma1 && !temTurma2) {
                                            textoAviso = "Previsto apenas na Turma 1";
                                        } else if (!temTurma1 && temTurma2) {
                                            textoAviso = "Previsto apenas na Turma 2";
                                        }
                                    }
                                }

                                return <>
                                    <h5 className='mt-2'><b>- {tituloItem}</b></h5>
                                    {textoAviso && (
                                        <div
                                            className="mt-1 mb-2 px-2 py-1"
                                            style={{
                                                color: '#c53030',
                                                backgroundColor: '#fff5f5',
                                                border: '1px solid #feb2b2',
                                                borderRadius: '4px',
                                                fontSize: '0.8rem',
                                                fontWeight: '600',
                                                display: 'inline-block'
                                            }}
                                        >
                                            ⚠️ {textoAviso}
                                        </div>
                                    )}
                                    {item?.professores?.map((professor, index) => {
                                        return <Row key={`professor-${item?.id}-${index}`} className="modal-grupos-aluno modal-ciclo">
                                            <Col md={10} className="modal-gerenciamento-tab-2">
                                                <SelectForm
                                                    style={{ col: style.col3 }}
                                                    indice={index}
                                                    label="Professor"
                                                    name="professor_id"
                                                    options={professoresConteudo(item?.professores_disponiveis, item?.id)}
                                                    placeholder="Selecione"
                                                    value={professor?.id ? professoresConteudo2(item?.professores_disponiveis)?.find(option => option.value === professor?.id) : ''}
                                                    onChange={(name, value, indice) => onChangeProfessor(name, value, indice, item?.id)}
                                                    estilo="teste"
                                                />
                                                <InputForm
                                                    style={{ col: style.col3 }}
                                                    indice={index}
                                                    label="Qtde. Questões Múltipla Escolha"
                                                    name="qtd_questoes_objetivas"
                                                    value={professor?.conteudo_prova_professor?.qtd_questoes_objetivas ?? ""}
                                                    onChange={(name, value, indice) => onChangeProfessor(name, value, indice, item?.id)}
                                                    estilo="teste"
                                                />
                                                <InputForm
                                                    style={{ col: style.col3 }}
                                                    indice={index}
                                                    name="qtd_questoes_subjetivas"
                                                    label="Qtde. Questões Discursivas"
                                                    value={professor?.conteudo_prova_professor?.qtd_questoes_subjetivas ?? ""}
                                                    onChange={(name, value, indice) => onChangeProfessor(name, value, indice, item?.id)}
                                                    estilo="teste"
                                                />
                                            </Col>
                                            <Col md={2} className="botoes-modal-gerenciamento">
                                                {/* Show add button on the last professor row */}
                                                {index === item?.professores.length - 1 && (
                                                    <FiPlus
                                                        onClick={() => onChangeCampos("mais", index, item?.id)}
                                                        className="menuIconsReplica"
                                                    />
                                                )}
                                                {/* Show remove button if there's more than one professor */}
                                                {item?.professores.length > 1 && (
                                                    <FiTrash2
                                                        onClick={() => onChangeCampos("menos", index, item?.id)}
                                                        className="menuIconsReplica"
                                                    />
                                                )}
                                            </Col>
                                        </Row>
                                    })}
                                </>
                            })}
                        </Table>
                    </TabPane>

                    <TabPane tabId={3}>
                        <Table striped>
                            {/* Tab 3 dinâmica baseada no estado conteudo (tab 2) */}
                            {/* Professores únicos para Tab 3 */}
                            {(() => {
                                // Coletamos informações de todos os professores relevantes
                                const professoresUnicosMap = new Map();

                                // Primeiro, adicionamos os professores do conteudo (dados originais da API)
                                // Adicionamos apenas o status_id ao professor
                                conteudo.forEach(item => {
                                    (item.professores || []).forEach(professor => {
                                        if (professor?.id) {
                                            const professorComStatus = {
                                                ...professor,
                                                status_id: professoresModificados[professor.id]?.status_id ??
                                                    professor.conteudo_prova_professor?.status_id ?? 1
                                            };
                                            professoresUnicosMap.set(professor.id, professorComStatus);
                                        }
                                    });
                                });

                                // A lista exibida vem direto do mapa (fonte única de verdade: o estado "conteudo",
                                // o mesmo que a aba "Professores x Conteúdo" usa). Antes, a exibição dependia do
                                // conjunto "professoresEmail" estar sincronizado corretamente, o que podia deixar
                                // um professor (ex: recém-vinculado a uma aula) fora desta aba mesmo já aparecendo
                                // corretamente na aba de Conteúdo.
                                const professoresParaExibir = Array.from(professoresUnicosMap.values());

                                // Ordena os professores pelo nome para fácil localização
                                professoresParaExibir.sort((a, b) => {
                                    const nomeA = (a.nome_social || a.nome || '').toLowerCase();
                                    const nomeB = (b.nome_social || b.nome || '').toLowerCase();
                                    return nomeA.localeCompare(nomeB);
                                });

                                return professoresParaExibir.map((professor) => (
                                    <Row key={`tab3-professor-${professor.id}`} className="modal-grupos-aluno modal-ciclo">
                                        <Col md={10} className="modal-gerenciamento-tab-2">
                                            <InputForm
                                                indice={professor.id}
                                                label="Professor"
                                                name="professor_id"
                                                value={professor.nome_social || professor.nome || ''}
                                                readOnly
                                                style={{ col: style.col3 }}
                                            />
                                            <InputForm
                                                indice={professor.id}
                                                label="Email"
                                                name="email"
                                                value={professoresModificados[professor.id]?.email ?? professor.email ?? ''}
                                                onChange={onChangeProfessor}
                                                style={{ col: style.col3 }}
                                            />
                                            <InputForm
                                                indice={professor.id}
                                                label="Telefone"
                                                name="telefone"
                                                value={professoresModificados[professor.id]?.telefone ?? professor.telefone ?? ''}
                                                onChange={onChangeProfessor}
                                                style={{ col: style.col3 }}
                                            />

                                            {(() => {
                                                const statusId = parseInt(encontrarProfessor(professor.id));
                                                let color = '';

                                                let fontWeight = 'normal';

                                                switch (statusId) {
                                                    case 1:
                                                        color = '#FF000A'; // vermelho
                                                        fontWeight = 'bold';
                                                        break;
                                                    case 2:
                                                        color = '#0049B8'; // azul
                                                        break;
                                                    case 3:
                                                        color = '#017E29'; // verde
                                                        break;
                                                    case 4:
                                                        color = '#FF9400'; // laranja
                                                        fontWeight = 'bold';
                                                        break;
                                                    case 5:
                                                        color = '#000000'; // preto
                                                        break;
                                                    default:
                                                        color = 'inherit';
                                                }

                                                const customStyles = {
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: color,
                                                        fontWeight: fontWeight
                                                    })
                                                };

                                                return (
                                                    <SelectForm
                                                        indice={professor.id}
                                                        label="Status"
                                                        name="status_id"
                                                        options={statusOptions}
                                                        value={statusOptions?.find(option => option.value === (professoresModificados[professor.id]?.status_id ?? statusId))}
                                                        placeholder="Selecione"
                                                        onChange={onChangeProfessor}
                                                        style={{ col: style.col3 }}
                                                    />
                                                );
                                            })()}
                                            <InputForm
                                                indice={professor.id}
                                                label="Data Visualizado"
                                                name="data_visualizado"
                                                value={formatarDataVisualizado(professor?.conteudo_prova_professor?.data_visualizado)}
                                                readOnly
                                                style={{ col: style.col3 }}
                                            />
                                        </Col>
                                        <Col md={2} className="checkbox-email">
                                            <h6>Enviar Email</h6>
                                            <input onChange={onChangeCheckbox} id={professor.id} type="checkbox" name="enviar_email" className="input-email" checked={professoresModificados[professor.id]?.enviar ?? false}></input>
                                        </Col>
                                    </Row>
                                ));
                            })()}
                        </Table>
                    </TabPane>

                    <TabPane className="itens-ciclo" tabId={4}>
                        <Table striped>
                            {console.log(dados)}
                            <TableWithVirtualizedRow
                                tabelaClassName="tabelaConsulta"
                                isGerenciamentoProva={true} //variavel para saber se vem da tela de conteudo prova
                                columns={[
                                    {
                                        Header: 'Aula',
                                        accessor: (row) => row.titulo ?? (row.aula_id !== null ? row.aula.titulo : row.servico_descricao.titulo),
                                        disabled: true,
                                        style: { width: (dados?.semestre_id != 9 || dados?.periodo_letivo_id != 10) ? '34%' : '42%' },
                                        id: 'nome_professor',
                                    },
                                    {
                                        Header: 'Data Turma 1',
                                        accessor: 'data_1',
                                        disabled: true,
                                        style: { width: (dados?.semestre_id != 9 || dados?.periodo_letivo_id != 10) ? '18%' : '24%' },
                                        id: 'array_data_1',
                                    },
                                    ...(dados?.semestre_id != 9 || dados?.periodo_letivo_id != 10 ? [{
                                        Header: 'Data Turma 2',
                                        accessor: 'data_2',
                                        disabled: true,
                                        style: { width: '18%' },
                                        id: 'array_data_2',
                                    }] : []),
                                    {
                                        Header: 'Professor',
                                        accessor: 'professores_unicos',
                                        disabled: true,
                                        arrayField: true,
                                        style: { width: (dados?.semestre_id != 9 || dados?.periodo_letivo_id != 10) ? '30%' : '34%' },
                                        id: 'array_professor',
                                        className: 'array_professor'
                                    }
                                ]}
                                data={conteudosTab4}
                            />
                        </Table>
                        {conteudosTab4 && conteudosTab4.length > 0 ? (
                            <Col sm={12} className="align-content-middle mb-3 p-0 mt-3">
                                <Button
                                    className="float-left export-btnConsulta"
                                    size="sm"
                                    onClick={() => getExportDownload()}
                                >
                                    <AiFillFileExcel size="1.2rem" style={{ padding: '1px' }} />
                                    Exportar XLSX
                                </Button>
                            </Col>
                        ) : null}
                    </TabPane>
                    <TabPane tabId={5}>
                        <Table striped>
                            <thead>
                                <tr>
                                    <th>Conteúdo</th>
                                    <th style={{ width: '120px' }}>Turma</th>
                                    <th>Data Aula</th>
                                    <th style={{ width: '180px' }}>Data Alteração</th>
                                    <th>O que mudou</th>
                                </tr>
                            </thead>
                            <tbody>
                                {alteracoesConteudo.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="text-center">Nenhuma alteração registrada até o momento.</td>
                                    </tr>
                                ) : (
                                    alteracoesConteudo.map((alteracao, idx) => (
                                        <tr key={idx} style={alteracao.novo ? { fontWeight: 'bold' } : undefined}>
                                            <td>
                                                {alteracao.novo && (
                                                    <span
                                                        title="Alteração desde a última vez que você visualizou esta prova"
                                                        style={{
                                                            display: 'inline-block',
                                                            width: '8px',
                                                            height: '8px',
                                                            borderRadius: '50%',
                                                            backgroundColor: '#2b6cb0',
                                                            marginRight: '6px'
                                                        }}
                                                    />
                                                )}
                                                {alteracao.conteudo_titulo}
                                            </td>
                                            <td style={{ width: '120px' }}>{alteracao.turma_id == 1 ? 'Turma 1' : alteracao.turma_id == 2 ? 'Turma 2' : 'Turma Única'}</td>
                                            <td>{alteracao.data_aula ? dateToPtBr(alteracao.data_aula) : '-'}</td>
                                            <td style={{ width: '180px' }}>{alteracao.data_evento ? dateAndHourLaravel(alteracao.data_evento) : '-'}</td>
                                            <td style={{ fontWeight: 'normal' }}>{alteracao.descricao}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </TabPane>
                </TabContent>
                {tab == 3 ?
                    <Row>
                        <Col className="align-content-middle mb-4">
                            <Button className="mx-3" onClick={() => enviarEmail()}>Enviar Email</Button>
                        </Col>
                    </Row> : ""}
                <Row>
                    <Col className="align-content-middle">
                        <Button className="mx-3" onClick={() => toggle()}>Cancelar</Button>
                        <Button className="mx-3" onClick={() => salvar()}>Salvar
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal >
    );
}